// NEW EVAL EXCLUSION REASONS
export const EVAL_EXCLUSION_REASONS = {
  DESIRED_TIMESLOTS_NOT_AVAILABLE: 'Desired Timeslots not available for Client',
  ELIGIBILITY_INACTIVE_CLIENT: 'Client is Inactive when running the eligibility check',
  ELIGIBILITY_ERROR: 'Error from Stedy when running the eligibility check',
  NO_PCP_INFO: `Client does not have their physician's information`,
};

export const DIRECT_SIGNUP_MIXPANEL_EVENTS = {
  ADD_SECONDARY_INSURANCE: 'Direct Signup v1 - Asked to add secondary insurance',
  CHANGE_APPOINTMENT: 'Direct Signup v1 - Asked to change appointment time',
  CHANGE_PAYMENT_METHOD: {
    FROM_PRIVATE_PAY: 'Direct Signup v1 - Asked to change payment method (was private pay)',
    FROM_INSURANCE: 'Direct Signup v1 - Asked to change payment method (was insurance)',
  },

  STEPS: {
    FILTERS: 'Direct Signup v1 - Starting flow - Enter filters',
    URL_FILTERS: 'Direct Signup v1 - Starting flow - Filters via URL params',
    LANDING_PAGE: {
      BASE: 'Direct Signup v1 - Landing Page',
      CHOSEN_SINGLE: 'Direct Signup v1 - Landing Page - Chosen Single Evaluation',
      CHOSEN_SPLIT: 'Direct Signup v1 - Landing Page - Chosen Split Evaluation',

      EXPERIMENT: {
        NO_LANDING_SPLITS: 'Direct Signup v1 - Experiment - No Landing Page - Split Eval',
        NO_LANDING_SINGLES: 'Direct Signup v1 - Experiment - No Landing Page - 60 Minute Eval',
        LANDING_PAGE_SPLITS: 'Direct Signup v1 - Experiment - Landing Page - Split Eval',
        LANDING_PAGE_SINGLES: 'Direct Signup v1 - Experiment - Landing Page - 60 Minute Eval',
      },
    },
    REDIRECT_TO_JOTFORM: {
      FULL_FORM: 'Direct Signup v1 - Redirect to JotForm - Full form',
      INSURANCE_CARD: 'Direct Signup v1 - Redirect to JotForm - Insurance card',
    },
    EVAL: {
      TIMESLOTS: 'Direct Signup v1 - Evaluation - Pick Time',
      SCHEDULE: {
        SINGLE: 'Direct Signup v1 - Evaluation - Schedule',
        SPLIT_FIRST: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - First split',
        SPLIT_SECOND: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Second split',
        SPLIT_PICK_THERAPIST: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Pick therapist',
        SKIP_SECOND_SPLIT: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Skipping Second split',
        BAILOUT_TO_SINGLE:
          'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Bailing out to single evaluation',
        BAILOUT_TO_SPLITS:
          'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Bailing out to split evaluations',

        FORCED_REDIRECTS: {
          SPLITS_NOT_ALLOWED: 'Direct Signup v1 - Evaluation - Schedule - Forcing single evaluation, user not allowed',

          SPLITS_UNAVAILABLE:
            'Direct Signup v1 - Evaluation - Schedule - Low availability for split evaluations - Redirecting to Jotform',

          SINGLES_UNAVAILABLE:
            'Direct Signup v1 - Evaluation - Schedule - Low availability for single evaluations - Redirecting to Jotform',

          PREFILLED_APPOINTMENT:
            'Direct Signup v1 - Evaluation - Schedule - Skipping schedule step due to prefilled appointment',
        },
      },
      FORM: {
        NO_PCP: 'Direct Signup v1 - No PCP',

        NO_PCP_BAILOUT: 'Direct Signup v1 - No PCP but REQUIRED - Bailout to jotform',
      },
      FORM_INSURANCE: {
        MEDICAID: 'Direct Signup v1 - Evaluation - Form - Insurance (medicaid)',
        MEDICARE: 'Direct Signup v1 - Evaluation - Form - Insurance (medicare)',
        COMMERCIAL: 'Direct Signup v1 - Evaluation - Form - Insurance (commercial)',
        OUT_OF_NETWORK: 'Direct Signup v1 - Evaluation - Form - Insurance (commercial - out of network)',
      },
      FORM_PRIVATE_PAY: 'Direct Signup v1 - Evaluation - Form - Private Pay',
      SUBMITTED: 'Direct Signup v1 - Evaluation - Submitted, redirecting to credentials creation',
      EXCLUSION: 'Direct Signup v1 - Evaluation Exclusion',
      DIVERTED: 'Direct Signup v1 - Diverted to Consult - Availability',
      IGNORED_DIVERT: 'Direct Signup v1 - Ignoring divert to consult due to being resumed LeadID',
    },
    PREBOOK: {
      VIEW: 'Direct Signup - Pre-Book - View',
      SUBMIT: {
        SCHEDULE_FIRST: 'Direct Signup - Pre-Book - Scheduled One Recurring Session',
        SCHEDULE_BOTH: 'Direct Signup - Pre-Book - Scheduled Two Recurring Sessions',
      },
      SKIPPED: 'Direct Signup - Pre-Book - Skipped',
      ERRORS: {
        AVAILABILITY: {
          FIRST_SESSION: 'Direct Signup - Pre-Book - Error - First Session No Longer Available',
          SECOND_SESSION: 'Direct Signup - Pre-Book - Error - Second Session No Longer Available',
          BOTH_SESSIONS: 'Direct Signup - Pre-Book - Error - Both Sessions No Longer Available',
        },
        GENERIC: 'Direct Signup - Pre-Book - General Server Error',
      },
    },
    CONSULT: {
      FORM: 'Direct Signup v1 - Consultation - Form',
      SUBMITTED: 'Direct Signup v1 - Consultation - Submitted, redirecting to thank you page',
    },
  },

  INSURANCE_CHECKS: {
    OK: 'Direct Signup v1 - Evaluation - Form - Insurance - Successful eligibility check',
    INACTIVE: 'Direct Signup v1 - Evaluation - Form - Insurance - Successful eligibility check',
    ERROR: 'Direct Signup v1 - Evaluation - Form - Insurance - FAILED eligibility check',
  },
};

export const INSURANCE_MAPPING: Record<'insurance-medicaid' | 'insurance-medicare' | 'privatePay', string> = {
  'insurance-medicaid': DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.MEDICAID,
  'insurance-medicare': DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_INSURANCE.MEDICARE,
  privatePay: DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_PRIVATE_PAY,
};
